import I18n from './I18n'
export default I18n